const axios = require('axios');
const config = require('../client_config/config');


const performGetRequest = async (endpoint, params = {}) => {
    const url = config.url.concat(endpoint);
    return axios.get(url, {params});
};

const performPostRequest = async (endpoint, payload = {}) => {
    const url = config.url.concat(endpoint);
    return axios.post(url, payload);
};

const performPutRequest = async (endpoint, payload = {}) => {
    const url = config.url.concat(endpoint);
    return axios.put(url, payload);
};

const performPatchRequest = async (endpoint, payload = {}) => {
    const url = config.url.concat(endpoint);
    return axios.patch(url, payload);
};

const performDeleteRequest = async (endpoint, params = {}) => {
    const url = config.url.concat(endpoint);
    return axios.delete(url, {params});
};


module.exports = {
    get: performGetRequest,
    post: performPostRequest,
    put: performPutRequest,
    patch: performPatchRequest,
    delete: performDeleteRequest
};
